var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-tickets","size":"mini"},on:{"click":function($event){return _vm.submit('edit')}}},[_vm._v(" "+_vm._s(_vm.$t('common.upload'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }